import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		'ddc.link.generic': [...mycarsSrpVdp.events['ddc.link.generic']],
		widgetUserEvent: [
			{
				logic: {
					widgetName: 'ws-vehicle-media',
					mustInclude: {
						'eventData.action': 'swiped'
					}
				},
				// needs to be a function so it calculates every time
				// also the reason this specific event mapping is not merged in with next event is because
				// having the payload be a function was preventing our untested item logic from working right
				payload: () => ({
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action:
						window?.DDC?.WidgetData?.['ws-tagging']
							?.swipeDirection === 'left'
							? 'swipe_left'
							: 'swipe_right',
					event_action_result:
						window?.DDC?.WidgetData?.['ws-tagging']
							?.swipeDirection === 'left'
							? 'increase'
							: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				})
			},
			{
				logic: {
					widgetName: 'ws-vehicle-media'
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'redirect',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						{
							logic: {
								mustInclude: {
									'eventData.element': 'Next'
								}
							},
							payload: {
								event_action_result: 'increase'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.element': 'Previous'
								}
							},
							payload: {
								event_action_result: 'decrease'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Opens gallery modal'
								}
							},
							payload: {
								event_action_result: 'open'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Opens photos'
								}
							},
							payload: {
								event_action_result: 'open'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Closes gallery modal'
								}
							},
							payload: {
								event_action_result: 'close'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Zooms into photo'
								}
							},
							payload: {
								event_action_result: 'increase'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Zooms out of photo'
								}
							},
							payload: {
								event_action_result: 'decrease'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Enters fullscreen mode'
								}
							},
							payload: {
								event_action_result: 'none'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Exits fullscreen mode'
								}
							},
							payload: {
								event_action_result: 'exit'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Opens video'
								}
							},
							payload: {
								event_action_result: 'open',
								media_type: 'video'
							}
						}
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-vehicle-gallery',
					mustInclude: {
						'eventData.action': 'swipe'
					}
				},
				// needs to be a function so it calculates every time
				// also the reason this specific event mapping is not merged in with next event is because
				// having the payload be a function was preventing our untested item logic from working right
				payload: () => ({
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action:
						window?.DDC?.WidgetData?.['ws-tagging']
							?.swipeDirection === 'left'
							? 'swipe_left'
							: 'swipe_right',
					event_action_result:
						window?.DDC?.WidgetData?.['ws-tagging']
							?.swipeDirection === 'left'
							? 'increase'
							: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				})
			},
			{
				logic: {
					widgetName: 'ws-vehicle-gallery'
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'redirect',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						{
							logic: {
								mustInclude: {
									'eventData.carouselDirection': 'next'
								}
							},
							payload: {
								event_action_result: 'increase'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.carouselDirection': 'previous'
								}
							},
							payload: {
								event_action_result: 'decrease'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Open gallery modal'
								}
							},
							payload: {
								event_action_result: 'open'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Close gallery modal'
								}
							},
							payload: {
								event_action_result: 'close'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result': 'Zoom into photo'
								}
							},
							payload: {
								event_action_result: 'increase'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.result':
										'Open video in gallery modal'
								}
							},
							payload: {
								event_action_result: 'open',
								media_type: 'video'
							}
						}
					]
				}
			}
		],
		commonDataLayerEvent: [
			{
				logic: {
					mustInclude: {
						'eventData.event.element':
							'Continue Deal Secondary Button',
						'eventData.event.application.name':
							'Unified Deal Starter'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.unifiedDealStarter]]'
					],
					flow_name: 'financing',
					flow_outcome: 'proceed',
					element_title: 'continue_to_sdp'
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.event.element':
							'Continue Deal Primary Button',
						'eventData.event.application.name':
							'Unified Deal Starter'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.unifiedDealStarter]]'
					],
					flow_name: 'financing',
					flow_outcome: 'start',
					element_title: 'submit_offr_bttn'
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.event.element': 'Get Trade-in Value Link',
						'eventData.event.application.name':
							'Unified Deal Starter'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.unifiedDealStarter]]'
					],
					flow_name: 'trade',
					flow_outcome: 'start',
					element_title: 'navigate_to_tradein'
				}
			},
			{
				logic: ({ eventData }) => {
					// We format it like this so that we don't get a bunch of TypeErrors since A LOT of CDLs get posted
					const { element, application } = eventData.event || {};

					const udsElementsToUse = [
						'Build Your Offer Toggle',
						'Credit Rating Dropdown',
						'Term Length Dropdown',
						'Estimate Trade-in Value Field',
						'Amount Owed Field',
						'Down Payment Field'
					];

					return (
						application?.name === 'Unified Deal Starter' &&
						udsElementsToUse.indexOf(element) > -1
					);
				},
				payload: ({ eventData }) => {
					const { element } = eventData.event || {};

					const getUdsFlowName = (elementName) => {
						switch (elementName) {
							case 'Credit Rating Dropdown':
							case 'Term Length Dropdown':
							case 'Down Payment Field':
								return 'financing';
							case 'Build Your Offer Toggle':
								return '[[eventData.event.elementText]]';
							default:
								return '';
						}
					};

					const udsElementTitle = {
						'Build Your Offer Toggle': 'payment_type',
						'Credit Rating Dropdown': 'credit_tier',
						'Term Length Dropdown': 'payment_term',
						'Estimate Trade-in Value Field': 'tradein',
						'Amount Owed Field': 'tradein',
						'Down Payment Field': 'down_payment'
					};

					return {
						shared: [
							'[[mapping.configuration.sharedPayloads.sharedProps]]',
							'[[mapping.configuration.sharedPayloads.vehicleData]]',
							'[[mapping.configuration.sharedPayloads.unifiedDealStarter]]'
						],
						flow_name: getUdsFlowName(element),
						flow_outcome: 'recalc',
						element_title: udsElementTitle[element]
					};
				},
				trigger: ['uds_profile_refresh']
			}
		]
	}
};
